import {ParameterStore} from '@/Core/mobx/ParameterStore/ParameterStore';
import {Grid, makeStyles, Typography} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {Outlist} from '../InstantAppModal';
import {useCommonModalStyles} from './common/modalStyles';
import FixedNavigation from './common/FixedNavigation';

interface ConditionalCoverageConfirmProps {
    parameterStore: ParameterStore;
    quoteResponse: Outlist[];
    onExit: () => void;
}

const useStyles = makeStyles(() => ({
    wrapper: {
        padding: '20px',
    },
    title: {
        fontFamily: 'LoraRegular',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '44px',
        lineHeight: '48.4px',
        color: '#456d69',
        marginBottom: '30px',
    },
    detailsWrap: {
        padding: '10px',
    },
    text: {
        fontFamily: 'LoraSemiBold',
        fontWeight: 700,
        fontSize: '24px',
        lineHeight: '28.8px',
        color: '#434343',
    },
    smallText: {
        fontFamily: 'FredokaLight',
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '25.6px',
        color: '#838383',
        marginTop: '18px',
    },
}));

const ConditionalCoverageConfirm: React.FC<ConditionalCoverageConfirmProps> = observer(
    ({parameterStore, quoteResponse, onExit}) => {
        const classes = useStyles();
        const commonClasses = useCommonModalStyles();
        const {approval} = parameterStore;
        const email = approval.emailAddress.value;
        const latestsDeathBenefit = quoteResponse?.find((qr) => qr.name === 'Initial death benefit')?.value;
        const optedIn = approval.conditionalCoverageElected.value === 'Yes';

        return (
            <>
                <Grid container classes={{root: classes.wrapper}}>
                    <Typography classes={{root: classes.title}} data-testId="conditionalCoverageConfirm">
                        {optedIn ? 'You’re Covered Starting At Midnight!' : 'You’re All Done For Now.'}
                    </Typography>
                    {optedIn ? (
                        <Grid container classes={{root: classes.detailsWrap}} spacing={4}>
                            <Grid item xs={9}>
                                <Typography classes={{root: classes.smallText}}>
                                    Beginning at midnight, you will be conditionally covered, which means that your
                                    beneficiaries are protected if you pass away during the underwriting of your
                                    application.
                                </Typography>
                                <Typography classes={{root: classes.smallText}}>
                                    We will send you an email at {email} with the full terms & conditions for
                                    Conditional Coverage.
                                </Typography>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container classes={{root: classes.detailsWrap}} spacing={4}>
                            <Grid item xs={9}>
                                <Typography classes={{root: classes.text}}>What Happens Next?</Typography>
                                <Typography classes={{root: classes.smallText}}>
                                    Our underwriters will need to review the application and may need additional
                                    information to finalize the app. We’ll make sure to email/text you in the next few
                                    days with any additional requirements.
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                    <FixedNavigation isLoading={false} onNext={onExit} onNextCustomText={'Back To Clients'} />
                </Grid>
            </>
        );
    },
);

export default ConditionalCoverageConfirm;
